import { Routes } from '@angular/router';
import { provideStates } from '@ngxs/store';
import { RolesGuard } from '../auth/services/roles-guard.service';
import { USER_ROLE } from '../shared/enums/user_roles.enum';
import { AdminDownloadsState } from './admin-downloads/state/admin-downloads/admin-downloads.state';
import { DownloadCategoriesState } from './admin-downloads/state/download-categories/download-categories.state';
import { DownloadItemState } from './admin-downloads/state/download-item/download-item.state';
import { StrengthscopeState } from './strengthscope/states/strengthscope.state';
import { UsersState } from './users/state/users.state';

export const dashboardRoute = 'dashboard';
export const usersRoute = 'users';
export const translationsRoute = 'translations';
export const downloadsRoute = 'downloads';
export const strengthscopeRoute = 'strengthscope';
export const surveysRoute = 'surveys';
export const impersonationRoute = 'impersonation';

export const ADMIN_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('./admin.component').then((m) => m.AdminComponent),
        children: [
            {
                path: '',
                redirectTo: dashboardRoute,
                pathMatch: 'full'
            },
            {
                path: dashboardRoute,
                loadComponent: () => import('./dashboard/dashboard.component').then((m) => m.DashboardComponent)
            },
            {
                path: usersRoute,
                loadComponent: () => import('./users/components/users.component').then((m) => m.UsersComponent),
                providers: [provideStates([UsersState])],
                canActivate: [RolesGuard],
                data: {
                    allowedRoles: [USER_ROLE.ADMIN]
                }
            },
            {
                path: translationsRoute,
                loadComponent: () =>
                    import('./translations/translations.component').then((m) => m.TranslationsComponent),
                canActivate: [RolesGuard],
                data: {
                    allowedRoles: [USER_ROLE.ADMIN, USER_ROLE.TRANSLATION_MANAGER]
                }
            },
            {
                path: downloadsRoute,
                loadChildren: () =>
                    import('./admin-downloads/admin-downloads.routes').then((m) => m.ADMIN_DOWNLOADS_ROUTES),
                providers: [provideStates([AdminDownloadsState, DownloadCategoriesState, DownloadItemState])],
                canActivate: [RolesGuard],
                data: {
                    allowedRoles: [USER_ROLE.ADMIN, USER_ROLE.DOWNLOAD_MANAGER]
                }
            },
            {
                path: strengthscopeRoute,
                loadComponent: () =>
                    import('./strengthscope/strengthscope.component').then((m) => m.StrengthscopeComponent),
                providers: [provideStates([StrengthscopeState])],
                canActivate: [RolesGuard],
                data: {
                    allowedRoles: [USER_ROLE.ADMIN, USER_ROLE.STRENGTHSCOPE_MANAGER]
                }
            },
            {
                path: surveysRoute,
                loadChildren: () => import('./surveys/surveys.routes').then((m) => m.SURVEY_ROUTES),
                canActivate: [RolesGuard],
                data: {
                    allowedRoles: [USER_ROLE.ADMIN, USER_ROLE.SURVEY_MANAGER]
                }
            },
            {
                path: impersonationRoute,
                loadComponent: () =>
                    import('./impersonation/impersonation.component').then((m) => m.ImpersonationComponent)
            }
        ]
    }
];
